import DynamicForm from "@/common/DynamicForm";
import { IntakeSectionHeader, StyledGridRow } from "@/common/styles";
import { Form } from "antd";
import { forwardRef, useEffect, useState } from "react";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { convertApiFields, isNonEmptyVariable } from "@/util/common_function";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import dayjs from "dayjs";

const AdditionalBookingInformation = () => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [form] = Form.useForm();
  const [apiFields, setApiFields] = useState([]);
  const [additionalBookingInfo, setAdditionalBookingInfo] = useState(null);
  const fullSearch = useSelector(state => state.fullSearch);
  const globalClientParam = useSelector(
    (state) => state.config.globalClientParam
  );

  // --- Fetch API Field Definitions ---
  useEffect(() => {
    getFieldsFromExtraAPI();
  }, []);

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      const abi = bookings?.arrestReports?.[0]?.arrestReportsExtra?.[0];
      const obj = {
        ...abi,
        dnaTestDateCompleted: isNonEmptyVariable(abi?.dnaTestDateCompleted)
          ? dayjs(abi?.dnaTestDateCompleted)
          : null,
        mantoux: isNonEmptyVariable(abi?.mantoux) ? dayjs(abi?.mantoux) : null,
      };
      setAdditionalBookingInfo(obj);
    } else {
      setAdditionalBookingInfo(null);
    }
  }, [bookings]);

  // Set the form’s initial values from formData (after transforming for display).
  useEffect(() => {
    if (isNonEmptyVariable(additionalBookingInfo)) {
      form.setFieldsValue(additionalBookingInfo);
    } else {
      form.resetFields();
    }
  }, [additionalBookingInfo]);

  const getFieldsFromExtraAPI = () => {
    api
      .get(API_ENDPOINTS.getBookingExtra)
      .then((response) => {
        let data = response?.data || [];

        // Step 1: Get all paramContext values
        const paramContexts = globalClientParam?.map(
          (p) => p.paramContext
        ) || [];

        // Step 2: Filter data
        const filteredData = data.filter((item) => {
          const columnName = item?.columnName;

          // Condition 1: must end with _U
          const endsWithU = columnName?.endsWith("_U");

          // Condition 2: should NOT exist in global paramContext
          const existsInGlobalParam = paramContexts?.includes(columnName);

          return endsWithU && !existsInGlobalParam;
        });

        // Step 3: Convert
        let converted = convertApiFields(filteredData, "ArrestReportsExtra");

        // Step 4: Apply date type
        converted = converted?.map((c) => {
          if (
            c?.columnName === "dnaTestDateCompleted" ||
            c?.columnName === "mantoux"
          ) {
            c.type = "date";
          }
          return c;
        });

        console.log("filtered + converted", converted);

        setApiFields(converted);
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  };

  // Merge current visible form values with hidden fields from formData, then transform keys before saving.
  const updateForm = (currentValues) => {
    console.log(currentValues);

    dispatch(
      setBookings({
        arrestReports: [
          {
            ...bookings?.arrestReports?.[0],
            arrestReportsExtra: [
              {
                ...bookings?.arrestReports?.[0]?.arrestReportsExtra?.[0],
                ...currentValues,
              },
            ],
          },
        ],
      })
    );
  };

  return (
    <>
      <Form
        form={form}
        onBlur={(e) => {
          if (
            e?.target?.id == "dnaTestDateCompleted" ||
            e?.target?.id === "mantoux"
          ) {
            return;
          }

          const values = form.getFieldsValue();
          values.dnaTestDateCompleted = values?.dnaTestDateCompleted
            ? dayjs(values?.dnaTestDateCompleted)?.format("MM/DD/YYYY")
            : null;
          values.mantoux = values?.mantoux
            ? dayjs(values?.mantoux)?.format("MM/DD/YYYY")
            : null;
          updateForm(values);
        }}
        onFieldsChange={(sf) => {
          if (
            sf?.[0]?.name?.[0] === "dnaTestDateCompleted" ||
            sf?.[0]?.name?.[0] === "mantoux"
          ) {
            const values = form.getFieldsValue();

            const data = {
              dnaTestDateCompleted: values?.dnaTestDateCompleted
                ? dayjs(values?.dnaTestDateCompleted)?.format("MM/DD/YYYY")
                : null,
              mantoux: values?.mantoux
                ? dayjs(values?.mantoux)?.format("MM/DD/YYYY")
                : null,
            };

            updateForm(data);
          }
        }}
        disabled={!bookingsFieldsEnabled}
      >
        <StyledGridRow gutter={[16]}>
          {apiFields?.map((sf, index) => (
            <DynamicForm
              key={index}
              formAttributes={sf}
              form={form}
              bookingsFieldsEnabled={bookingsFieldsEnabled}
              fullSearch={fullSearch}
            />
          ))}
        </StyledGridRow>
      </Form>
    </>
  );
};

export default AdditionalBookingInformation;
